import {
  Autocomplete,
  Box,
  BoxStatus,
  Description,
  GraphicFilters,
  Heading,
  Input,
  Label,
  PieCharts,
  Select,
  shootToast,
  Stack,
  StackRow,
} from "codekit";
import {
  useGenerateExcelMutation,
  useGetDataGraphicMutation,
  useGetDataGroupsMutation,
} from "../../../../libs/redux/slices/Graficsx/Ingeprop/ingepropApiSlice";
import {
  useGetEntregauGerenciasQuery,
  useLazyGetEntregauGruposQuery,
} from "../../../../libs/redux/slices/Graficsx/Entregau/entregauApiSlice";
import { useCallback, useEffect, useState } from "react";
import Panclien from "./Ingeprop/Panclien";
import Paneject from "./Ingeprop/Paneject";
import { useGetClientGraphicByIdMutation } from "../../../../libs/redux/slices/Reportxx/Repfinac/repfinacApiSlice";
import { Controller, useForm, useWatch } from "react-hook-form";
import { convertCurrencyNumber, getActualDate } from "../../../../utils/globalFunctions";

const colorChart = ["secondary", "success", "warning", "error", "accent", "primary", "info"];

const Ingeprop = ({ graphName }) => {
  const [getClientById] = useGetClientGraphicByIdMutation();
  const [resultsClient, setResultsClient] = useState([]);
  const [getDataGraphic] = useGetDataGraphicMutation();
  const [getDataGroups] = useGetDataGroupsMutation();
  const [generateExcel] = useGenerateExcelMutation();
  const [getGrupos] = useLazyGetEntregauGruposQuery();
  const { data: gerenciasData } = useGetEntregauGerenciasQuery();
  const gerenciasOpts = [
    { text: "SELECCIONE", value: "" },
    ...(gerenciasData?.data ?? []).map((item) => ({ text: item.text, value: item.CCOIDXXX, GRUPIDXX: item.value })),
  ];
  const [total, setTotal] = useState(0);
  const [dataGraphic, setDataGraphic] = useState([]);
  const [colorsChart, setColorsChart] = useState([]);
  const [gruposOpts, setGruposOpts] = useState([{ text: "SELECCIONE", value: "" }]);
  const firstDate = `${getActualDate().substring(0, 8)}01`;
  const { control, register, reset, setValue } = useForm({
    mode: "onBlur",
    defaultValues: {
      FECHINIT: firstDate,
      FECHFINT: getActualDate(),
      TIPOFILT: "FACTURACION",
      CCOIDXXX: "",
      GRUPIDXX: "",
      GERENCIX: "",
    },
  });
  const values = useWatch({ control });
  const gerenciaVal = values.GERENCIX;
  const [dataGraphicGroups, setDataGraphicGroups] = useState([]);
  const [isGraphicGroups, setGraphicGroups] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCsolOpen,      setIsCsolOpen]      = useState(false);
  const [isEjeOpen,       setIsEjeOpen]       = useState(false);
  const [alertClients,    setAlertClients]    = useState(null);
  const [gerenciaFilter,  setGerenciaFilter]  = useState(null);

  useEffect(() => {
    setValue("GRUPIDXX", "");
    setGruposOpts([{ text: "SELECCIONE", value: "" }]);
    if (!gerenciaVal) {
      return;
    }
    getGrupos({ filters: { GRUPIDXX: gerenciaVal } })
      .unwrap()
      .then((res) => setGruposOpts([{ text: "SELECCIONE", value: "" }, ...(res.data ?? [])]))
      .catch(() => {});
  }, [gerenciaVal, getGrupos, setValue]);

  const searchClient = async (CLIIDXXX, cb) => {
    return await getClientById({
      filters: { CLIIDXXX },
    })
      .unwrap()
      .then((response) => {
        setResultsClient(response.data);
      })
      .catch((err) => {
        console.log("entro en el catch", err);
      })
      .finally(() => {
        cb();
      });
  };

  //Funcion que retorna los colores para el pintado de la grafica
  const getColorByIndex = (index) => {
    const colorIndex = index % colorChart.length;
    const baseColor = colorChart[colorIndex];

    return {
      colorCellChart: `${baseColor}-500`,
      bgColorCards: `${baseColor}-100`,
      iconColor: `${baseColor}-400`,
      textColor: `${baseColor}-600`,
    };
  };

  //Funcion para la consulta de informacion de la Graphica
  const handleGetData = useCallback(
    async (values) => {
      setIsLoading(true);
      let filters = {};
      filters = {
        ...values,
        CLIIDXXX: values.CLIIDXXX ? values.CLIIDXXX.split(" - ")[0] : "",
      };
      await getDataGraphic({ filters })
        .unwrap()
        .then((response) => {
          const { data } = response;
          let totalData = 0;
          let percentage = {};
          data.forEach((element) => {
            totalData += parseFloat(element.MDTCVLRX);
          });
          data.forEach((element) => {
            const value = (parseFloat(element.MDTCVLRX) * 100) / totalData;
            percentage = {
              ...percentage,
              [element.CCOIDXXX]: value.toFixed(2),
            };
          });
          setDataGraphic(
            data.map((item) => ({
              name: item.CCODESXX ?? "INGRESOS ADMINISTRATIVOS",
              value: parseFloat(item.MDTCVLRX),
              date: `${percentage[item.CCOIDXXX]} %`,
              CCOIDXXX: item.CCOIDXXX,
            })),
          );
          setColorsChart(data.map((item, index) => getColorByIndex(index)));
          setTotal(totalData);
        })
        .catch();
      setIsLoading(false);
    },
    [getDataGraphic],
  );

  //Funcion para la generacion del excel
  const handleGenerateExcel = async (context) => {
    let filters = {
      ...values,
      CLIIDXXX: values.CLIIDXXX ? values.CLIIDXXX.split(" - ")[0] : "",
    };
    if (context) {
      const {
        data: { CCOIDXXX, GRUPIDXX },
      } = context;
      filters = { ...filters, CCOIDXXX, GRUPIDXX };
    }
    await generateExcel({ filters })
      .unwrap()
      .then(() => {
        shootToast({
          variant: "success",
          text: "Tu reporte se esta generando! \n En Pocos minutos recibiras las confirmación del mismo por correo electronico",
          duration: 5000,
        });
      })
      .catch();
  };

  /**
   * Funcion para consultar los ingresos por grupos de una gerencia
   */
  const handleViewGroups = useCallback(
    async (values) => {
      let filters = {
        ...values,
        CLIIDXXX: values.CLIIDXXX ? values.CLIIDXXX.split(" - ")[0] : "",
      };
      await getDataGroups({ filters })
        .unwrap()
        .then((response) => {
          const { data } = response;
          let totalData = 0;
          let percentage = {};
          data.forEach((element) => {
            totalData += parseFloat(element.MDTCVLRX);
          });
          data.forEach((element) => {
            const value = (parseFloat(element.MDTCVLRX) * 100) / totalData;
            percentage = {
              ...percentage,
              [element.GRUPIDXX]: value.toFixed(2),
            };
          });
          setDataGraphicGroups(
            data.map((item) => ({
              name: item.GRUPDESX,
              value: parseFloat(item.MDTCVLRX),
              date: `${percentage[item.GRUPIDXX]} %`,
              CCOIDXXX: item.CCOIDXXX,
              GRUPIDXX: item.GRUPIDXX,
            })),
          );
          setColorsChart(data.map((item, index) => getColorByIndex(index)));
          setTotal(totalData);
        })
        .catch();
    },
    [getDataGroups],
  );

  //Hook para volver a realizar consulta cuando cambia algun filtro
  useEffect(() => {
    if (!isGraphicGroups) {
      handleGetData(values);
    } else {
      handleViewGroups(values);
    }
  }, [handleGetData, values, isGraphicGroups, handleViewGroups]);

  return (
    <>
      <Box spacing={4}>
        <GraphicFilters
          containerName={graphName}
          graphicKeyName="ingeprop"
          clearFilters={() => {
            reset();
            setGraphicGroups(false);
            setGruposOpts([{ text: "SELECCIONE", value: "" }]);
          }}
          onClickVerMas={() => {
            handleGenerateExcel();
          }}
        >
          <Box>
            <Box mb={8} borderBottom={1} spacing={2}>
              <Stack gap={3} columnsVariant="form-3">
                <StackRow>
                  <Label>Cliente y/o Aliado</Label>
                  <Controller
                    control={control}
                    name={`CLIIDXXX`}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        placeholder="Buscar..."
                        textLoading="Buscando..."
                        textNoResults="No se encontraron registros"
                        minLengthToSearch={2}
                        selected={value}
                        searchResults={resultsClient}
                        onChangeSearch={(value, cb) => searchClient(value, cb)}
                        onItemClick={(context) => {
                          onChange(`${context.item.label}`);
                        }}
                        onResetSelected={() => {
                          onChange("");
                        }}
                      />
                    )}
                  />
                </StackRow>
                <StackRow>
                  <Label>Fecha Inicial</Label>
                  <Input type="date" {...register("FECHINIT")} />
                </StackRow>
                <StackRow>
                  <Label>Fecha Final</Label>
                  <Input type="date" {...register("FECHFINT")} />
                </StackRow>
                <StackRow>
                  <Label>Tipo de Operación</Label>
                  <Controller
                    control={control}
                    name={`DOCTIPXX`}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        options={[
                          { text: "SELECCIONE", value: "" },
                          { text: "IMPORTACION", value: "IMPORTACION" },
                          { text: "EXPORTACION", value: "EXPORTACION" },
                          { text: "REGISTRO", value: "REGISTRO" },
                          { text: "TRANSITO", value: "TRANSITO" },
                          { text: "OTROS", value: "OTROS" },
                        ]}
                        onChangeValue={(context) => {
                          onChange(context.option.value);
                        }}
                      />
                    )}
                  />
                </StackRow>
                <StackRow>
                  <Label>Gerencia</Label>
                  <Controller
                    control={control}
                    name="CCOIDXXX"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        options={gerenciasOpts}
                        onChangeValue={(context) => {
                          onChange(context.option.value);
                          setValue("GERENCIX", context.option.GRUPIDXX);
                        }}
                      />
                    )}
                  />
                </StackRow>
                <StackRow>
                  <Label>Grupo de Gestión</Label>
                  <Controller
                    control={control}
                    name="GRUPIDXX"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        options={gruposOpts}
                        onChangeValue={(context) => {
                          onChange(context.option.value);
                        }}
                      />
                    )}
                  />
                </StackRow>
              </Stack>
            </Box>
            <Box>
              {isLoading ? (
                <BoxStatus variant="loading" text="Cargando Información..." />
              ) : (
                <>
                  {!isGraphicGroups ? (
                    <>
                      {dataGraphic.length > 0 ? (
                        <Stack gap={8}>
                          <StackRow>
                            <PieCharts
                              onClickCellChart={(context) => {
                                setValue("CCOIDXXX", context?.data?.CCOIDXXX ?? "");
                                setGraphicGroups(true);
                              }}
                              onClickIconCard={(context) => {
                                handleGenerateExcel(context);
                              }}
                              onClickCard={(context) => {
                                setValue("CCOIDXXX", context?.data?.CCOIDXXX ?? "");
                                setGraphicGroups(true);
                              }}
                              data={dataGraphic}
                              chartColors={colorsChart}
                              labelOne={convertCurrencyNumber(total)}
                              labelTwo="Ingresos"
                              isCurrency={true}
                              titleIcon="Generar Excel"
                            />
                          </StackRow>
                          <StackRow>
                            <Stack gap={3} columnsVariant="form-2">
                              <StackRow>
                                <Stack bg="error-500" gap={2} spacing={4} rounded="md" className="cursor-pointer" onClick={() => setIsCsolOpen(true)}>
                                  <Heading variant="heading-5" color="error-100">RESUMEN CONSOLIDADO POR CLIENTE</Heading>
                                  <Description variant="description-3" color="error-100">Ver detalle por cliente →</Description>
                                </Stack>
                              </StackRow>
                              <StackRow>
                                <Stack bg="secondary-700" gap={2} spacing={4} rounded="md" className="cursor-pointer" onClick={() => setIsEjeOpen(true)}>
                                  <Heading variant="heading-5" color="secondary-100">INFORME EJECUTIVO</Heading>
                                  <Description variant="description-3" color="secondary-100">KPIs, Pareto y comparativo año anterior →</Description>
                                </Stack>
                              </StackRow>
                            </Stack>
                          </StackRow>
                        </Stack>
                      ) : (
                        <BoxStatus variant="empty" text="Esta sección está vacía" />
                      )}
                    </>
                  ) : (
                    <>
                      {dataGraphicGroups.length > 0 ? (
                        <Stack gap={8}>
                          <StackRow>
                            <PieCharts
                              onClickCellChart={(context) => {
                                handleGenerateExcel(context);
                              }}
                              onClickIconCard={(context) => {
                                handleGenerateExcel(context);
                              }}
                              data={dataGraphicGroups}
                              chartColors={colorsChart}
                              labelOne={convertCurrencyNumber(total)}
                              labelTwo="Ingresos"
                              isCurrency={true}
                              titleIcon="Generar Excel"
                            />
                          </StackRow>
                        </Stack>
                      ) : (
                        <BoxStatus variant="empty" text="Esta sección está vacía" />
                      )}
                    </>
                  )}
                </>
              )}
            </Box>
          </Box>
        </GraphicFilters>
      </Box>
      <Paneject
        isOpen={isEjeOpen}
        onClose={() => setIsEjeOpen(false)}
        filters={values}
        onOpenClients={(clients) => { setAlertClients(clients ?? null); setIsEjeOpen(false); setIsCsolOpen(true); }}
        onOpenGerencia={(id, name) => { setGerenciaFilter({ id, name }); setAlertClients(null); setIsEjeOpen(false); setIsCsolOpen(true); }}
      />
      <Panclien
        isOpen={isCsolOpen}
        onClose={() => { setIsCsolOpen(false); setAlertClients(null); setGerenciaFilter(null); }}
        filters={values}
        alertClients={alertClients}
        gerenciaId={gerenciaFilter?.id ?? null}
        gerenciaName={gerenciaFilter?.name ?? null}
      />
    </>
  );
};

export default Ingeprop;
